module.exports = __webpack_public_path__ + "img/wrongquestion.fd0664b8.png";